import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy" updated="May 13, 2026">
      <p>
        CoreLink Technologies Inc. ("the Company", "we", "us", or "our") operates AutoLink (the "Service"). This Privacy
        Policy describes how we collect, use, disclose, and safeguard user and dealership data when you use our platform.
        By accessing or using the Service, you consent to the data practices described in this policy.
      </p>

      <div>
        <h3>1. Information We Collect</h3>
        <p>To provide inventory management and automotive advertising tools, we collect the following types of information:</p>
        <ul>
          <li><strong>Dealership Information:</strong> Contact names, email addresses, phone numbers, dealership names, business addresses, and Meta/Facebook Page IDs.</li>
          <li><strong>Vehicle Inventory Data:</strong> Vehicle Identification Numbers (VINs), mileage, pricing, makes, models, trims, descriptions, and vehicle photographs.</li>
          <li><strong>Financial and Transaction Data:</strong> Payment tracking records, recurring subscription billing information, and sales margins entered into the app. Please note that credit card processing is handled securely by our third-party provider, Stripe; we do not store raw credit card details on our servers.</li>
        </ul>
      </div>

      <div>
        <h3>2. How We Use Your Information</h3>
        <p>We use the collected data to:</p>
        <ul>
          <li>Maintain, monitor, and optimize the functionality of your inventory dashboard.</li>
          <li>Process subscription payments and track overages via Stripe.</li>
          <li>Generate inventory logs and automated expense calculations.</li>
          <li>Transmit vehicle data to third-party platforms (such as Facebook Marketplace) upon your explicit command.</li>
        </ul>
      </div>

      <div>
        <h3>3. Third-Party Data Sharing (Meta / Facebook Integration)</h3>
        <p>AutoLink allows dealerships to sync vehicle data with Meta platforms via the Meta Graph/Marketing APIs.</p>
        <ul>
          <li>When you enable the Facebook Marketplace integration, you authorize AutoLink to transmit your vehicle inventory data, photos, pricing, and specific Facebook Page IDs to Meta Platforms, Inc.</li>
          <li>Data shared with Meta is subject to the Meta Privacy Policy. We do not share your private financial metrics, expense tracking, or user passwords with Meta.</li>
        </ul>
      </div>

      <div>
        <h3>4. Data Security</h3>
        <p>
          We implement industry-standard administrative, technical, and physical security measures to protect your dealership
          data. This includes database encryption, HTTPS data transmission, and regular system backups. However, no data
          transmission over the Internet can be guaranteed 100% secure.
        </p>
      </div>

      <div>
        <h3>5. Data Retention and Deletion</h3>
        <p>
          We retain your information for as long as your account is active or as needed to provide services. Dealerships
          may request the complete deletion of their account and all associated inventory data at any time.
        </p>
      </div>

      <div>
        <h3>6. Meta Developer Compliance: Data Deletion Requests</h3>
        <p>
          In accordance with Meta Platform Terms, users who have linked their Facebook profiles or business pages to
          AutoLink can request the removal of their data:
        </p>
        <ul>
          <li>To request data deletion, please contact our data controller at <a href="mailto:privacy@corelinktech.com">privacy@corelinktech.com</a>.</li>
          <li>Upon receiving your request, we will delete all stored user authentication tokens, associated Meta metadata, and connected inventory links within thirty (30) days and provide confirmation.</li>
        </ul>
      </div>

      <div>
        <h3>7. Governing Law</h3>
        <p>
          This Privacy Policy is governed by and construed in accordance with the laws of the Province of Alberta and the
          federal laws of Canada applicable therein.
        </p>
      </div>

      <div>
        <h3>8. Contact Information</h3>
        <p>If you have any questions or concerns regarding this Privacy Policy, please contact us at:</p>
        <p className="!mb-0">
          <strong>CoreLink Technologies Inc.</strong><br />
          Edmonton, Alberta, Canada<br />
          Email: <a href="mailto:contact@corelinktechnologies.ca">contact@corelinktechnologies.ca</a>
        </p>
      </div>
    </PolicyLayout>
  );
}
